import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const PARTNER_SETTLEMENT: AppRouteRecordRaw = {
  path: '/partner-settlement',
  name: 'partner-settlement',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '运营商结算',
    icon: 'icon-safe',
    requiresAuth: true,
    order: 16,
  },
  children: [
    {
      path: 'config',
      name: 'PartnerSettlementConfig',
      component: () => import('@/views/partner-settlement/config/index.vue'),
      meta: {
        locale: '结算配置',
        requiresAuth: true,
      },
    },
    {
      path: 'receiver',
      name: 'PartnerSettlementReceiverList',
      component: () => import('@/views/partner-settlement/receiver/index.vue'),
      meta: {
        locale: '分佣人管理',
        requiresAuth: true,
      },
    },
    {
      path: 'receiver/form',
      name: 'PartnerSettlementReceiverForm',
      component: () => import('@/views/partner-settlement/receiver/form.vue'),
      meta: {
        locale: '分佣人表单',
        requiresAuth: true,
        hideInMenu: true,
      },
    },
    {
      path: 'bill',
      name: 'PartnerSettlementBill',
      component: () => import('@/views/partner-settlement/bill/index.vue'),
      meta: {
        locale: '结算账单',
        requiresAuth: true,
      },
    },
  ],
};

export default PARTNER_SETTLEMENT;
